import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import Element from '~/src/components/element/Element';
import Slide from '~/src/components/slideshow/slide/SlideshowSlide';

import {SlideshowFormat} from '~/src/utilities/constants/formats';
import {ImageSize} from '~/src/utilities/constants/image';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import {classNames} from '~/src/utilities/helpers/css';

import css from './SlideshowSlides.module.scss';

const SlideshowSlides = ({slides, format, onClick, direction, index = 0}) => {
    const {siteArea} = useContext(SettingsContext);
    const imageSizes = format === SlideshowFormat.SLIDESHOW_INLINE ? ImageSize.CONTENT : ImageSize.FULLSCREEN;

    const className = classNames(css, 'slides', siteArea, format);

    return (
        <div className={className} onClick={onClick}>
            {slides.map((slide, position) => {
                const elements = [];

                if (slide.type !== 'slidePlaceholder') {
                    const image = {
                        ...slide.image,
                        sizes: imageSizes
                    };
                    elements.push(<Element key={position} {...slide} image={image} format={format} />);
                } else {
                    elements.push(<div key={position} className={css.placeholder}></div>);
                }

                return (
                    <Slide key={`${format}_${position}`} active={position === index} direction={direction} format={format}>
                        {elements}
                    </Slide>
                );
            })}
        </div>
    );
};

if (process.env.NODE_ENV === 'development') {
    SlideshowSlides.propTypes = {
        slides: PropTypes.array.isRequired,
        format: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        direction: PropTypes.string,
        index: PropTypes.number
    };
}

export default SlideshowSlides;
